module.exports = __webpack_public_path__ + "img/bg_las-vegas-market_entertainment-landscape.13184d34.jpg";